module.exports = __webpack_public_path__ + "img/JPM_Gradient_03.6e286c3f.jpg";